import React from 'react';
import { Card, CardBody, Col, Row, Table, ButtonGroup, Button} from 'reactstrap';
import { connect } from 'react-redux';
import { UsersGroupsPermissionAction } from 'redux/actions';
import { checkPermissions } from 'hooks';
import { useParams } from "react-router-dom";

const ManageUserPermissions = (props) => {

    const { userId } = useParams();
    const isFirstRender = React.useRef(true);

    React.useEffect(() => {
        if (isFirstRender.current) {
            props.getUserPermission({ user_id: userId })
            isFirstRender.current = false;
        }
    })

    const handleClick = (permissionId) => {
        props.updateUserPermission({ user_id: userId, permission_id: permissionId });
    }

    React.useEffect(() => {
        props.getUserPermission({ user_id: userId })
    }, [props.userPermAdded])

    const generateRow = (userPermissions) => {
        return (
            (userPermissions.length > 0) ?
                userPermissions.map((item, index) => (
                    <tr key={index}>
                        <td>{item.name}</td>
                        <td>
                            <ButtonGroup>
                                <Button outline={(item.user_permission_count) ? false : true}
                                    color="primary"
                                    onClick={() => handleClick(item.id)}
                                    active={(item.group_permission_count) ? true : false}
                                    disabled={(item.user_permission_count || !checkPermissions(props.loginData, 'user_permissions_update')) ? true : false}
                                >
                                    YES
                                </Button>
                                <Button
                                    outline={(!item.user_permission_count) ? false : true}
                                    color="primary"
                                    onClick={() => handleClick(item.id)}
                                    active={(!item.user_permission_count) ? true : false}
                                    disabled={(!item.user_permission_count || !checkPermissions(props.loginData, 'user_permissions_update')) ? true : false}
                                >
                                    NO
                                </Button>
                            </ButtonGroup>
                        </td>
                    </tr>)
                ) : <tr><td colSpan={"2"} align='center'></td></tr>
        )
    }


    return (
        <div>

            <Row>
                <Col>
                    <div style={{padding:10}} >Username: <span style={{fontWeight:500,color:'#00aee4'}}>{(props.user && props.user.username) && props.user.username}</span></div>
                    <Card className="mb-3">
                        <CardBody>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Page</th>
                                        <th>Has Permissions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {generateRow(props.userPermissions)}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>

    );
}
const mapStateToProps = (state) => ({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    userPermissions: (state.groupsPermission &&
        state.groupsPermission.userPermissions &&
        state.groupsPermission.userPermissions.data) ?
        state.groupsPermission.userPermissions.data : [],
    user: (state.groupsPermission &&
        state.groupsPermission.userPermissions &&
        state.groupsPermission.userPermissions.user) ?
        state.groupsPermission.userPermissions.user : {},
    userPermAdded: (state.groupsPermission &&
        state.groupsPermission.userPermAdded) ?
        state.groupsPermission.userPermAdded : null,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    getUserPermission: (payload) => dispatch(UsersGroupsPermissionAction.getUserPermission(payload)),
    updateUserPermission: (payload) => dispatch(UsersGroupsPermissionAction.updateUserPermission(payload)),
    clearPermission: () => dispatch(UsersGroupsPermissionAction.getGroupPermissionSuccess([]))
});
export const UserPermissions = connect(mapStateToProps, mapDispatchToProps)(ManageUserPermissions);